const baseOptions = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  sampleRate: 1,
  enabled: process.env.NEXT_PUBLIC_STAGE !== 'LOC',
  environment: process.env.NEXT_PUBLIC_STAGE,
  normalizeDepth: 6,
  // Release Health: track sessions per release for Crash-Free Users %
  // (sessions are not separately billed on am3 tier).
  autoSessionTracking: true,
};

export default baseOptions;
